export default "__VITE_ASSET__C854hz9z__"